export function ReplaceUnsupportedCharacters(filename: string): string {
    if (filename != null) {
        // Replaces ['\\', '/', ':', '*', '?', '"', '<', '>', '|'] with '-'
        filename = filename.replace(/\\|\||:|\*|\?|\"|<|>|\//g, '-');
    }
    return filename;
}
